import moment from 'moment';

/**
 *  formatSeconds - Formats seconds into a human readable format ${hours}h ${minutes}m ${seconds}s
 */
export const formatSeconds = (value: string | number) => {
  const safeConvertStringToNumber = typeof value === 'number' ? value : Number((value || '').replace(/,/g, ''));

  if (
    Number.isNaN(safeConvertStringToNumber) ||
    typeof safeConvertStringToNumber !== 'number' ||
    safeConvertStringToNumber < 1
  )
    return `${safeConvertStringToNumber || 0}s`;

  // value is in seconds
  const duration = moment.duration(safeConvertStringToNumber, 'seconds');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  let formattedValue = '';

  if (hours > 0) {
    formattedValue += `${hours}h `;
  }

  if (minutes > 0) {
    formattedValue += `${minutes}m `;
  }

  if (seconds > 0) {
    formattedValue += `${seconds}s`;
  }

  return formattedValue.trim();
};
